import { z } from 'zod';

export const WireKindSchema = z.enum(['control', 'power', 'sensor', 'other']);

export const WireEndSchema = z.object({
  hardware_id: z.string().min(1),
  pin: z.number().int().min(0).max(255),
  channel_id: z.string().nullable(),
});

export const WireSchema = z.object({
  id: z.string().min(1),
  project_id: z.string().min(1),
  ends: z.tuple([WireEndSchema, WireEndSchema]),
  kind: WireKindSchema,
  label: z.string().nullable(),
  connector_id: z.string().nullable(),
  archived_at_ms: z.number().int().nullable(),
  created_at_ms: z.number().int().nonnegative(),
  updated_at_ms: z.number().int().nonnegative(),
});

export const CreateWireSchema = WireSchema.omit({
  id: true,
  created_at_ms: true,
  updated_at_ms: true,
});

export type ParsedWireKind = z.infer<typeof WireKindSchema>;
export type ParsedWireEnd = z.infer<typeof WireEndSchema>;
export type ParsedWire = z.infer<typeof WireSchema>;
export type ParsedCreateWire = z.infer<typeof CreateWireSchema>;
